var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6959 7.03889C10.6959 9.11956 8.68504 10.576 6.50004 10.576C4.31504 10.576 2.30421 9.11956 2.30421 7.03889H0.958374C0.958374 9.40392 3.11171 11.3597 5.70837 11.6996V13.9745H7.29171V11.6996C9.88837 11.3597 12.0417 9.40392 12.0417 7.03889H10.6959ZM5.55004 2.80819C5.55004 2.35044 5.97754 1.97592 6.50004 1.97592C7.02254 1.97592 7.45004 2.35044 7.45004 2.80819L7.44212 7.10824C7.44212 7.56599 7.02254 7.94051 6.50004 7.94051C5.97754 7.94051 5.55004 7.56599 5.55004 7.10824V2.80819ZM6.50004 9.11956C7.12993 9.11956 7.73402 8.90035 8.17942 8.51014C8.62482 8.11994 8.87504 7.59072 8.87504 7.03889V2.87755C8.87504 2.32572 8.62482 1.79649 8.17942 1.40629C7.73402 1.01609 7.12993 0.796875 6.50004 0.796875C5.87015 0.796875 5.26606 1.01609 4.82066 1.40629C4.37526 1.79649 4.12504 2.32572 4.12504 2.87755V7.03889C4.12504 7.59072 4.37526 8.11994 4.82066 8.51014C5.26606 8.90035 5.87015 9.11956 6.50004 9.11956Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalks);
export default __webpack_public_path__ + "static/media/talks.2dfdf809.svg";
export { ForwardRef as ReactComponent };